module.exports = __webpack_public_path__ + "static/media/BICNY_Logo.5ea0255e.png";